export const Constants = {
  attachments: 'Anexos',
  files: 'Arquivos',
  propertyReg: 'Matrícula do imóvel',
  iptu: 'IPTU',
  selectFile: 'selecionar arquivo',
  exportSamples: 'Dados do cálculo e formulário',
  report: 'Relatório',
  add: 'adicionar',
  edit: 'editar',
  cancel: 'cancelar',
};
